import { ReactNode } from 'react';
import { Tabs, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from 'hooks';

type Props = {
  children: ReactNode;
  value: string;
  Icon?: ReactNode;
};

export const SidebarTabsTab = ({ children, value, Icon }: Props) => {
  const theme = useMantineTheme();
  const isSmBreakpoint = useMediaQuery(
    `(min-width: ${theme.breakpoints.sm}px)`,
  );
  const icon = isSmBreakpoint ? Icon : null;

  return (
    <Tabs.Tab value={value} icon={icon}>
      {children}
    </Tabs.Tab>
  );
};
